// https://github.com/dozoisch/react-google-recaptcha#advanced-usage
window.recaptchaOptions = {
  // lang: 'fr',
  useRecaptchaNet: true, // We wanna use thisone, because of china blocking
};

export {};
